<template>
  <v-app-bar
    class="main-header"
    height="64"
    fixed
    color='black'
    dark>
    <v-btn icon class="mx-1" @click="toggleMenu">
      <template v-if="menuIsOpen">
        <v-icon  style="font-size: 28px">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon style="font-size: 28px">mdi-menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>Control de equipos</v-toolbar-title>
    <v-spacer></v-spacer>
    
    <!-- <Search /> -->
    <v-menu
      min-width="180"
      offset-y
      bottom
      left
      nudge-bottom="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-0"
            icon
            v-bind="attrs"
            v-on="on">
            <v-icon
              style="font-size: 28px"
              >mdi-account</v-icon>
            </v-btn>
        </template>
        <v-list >
          <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{userAuth.nombre}}</div>
          <!-- <div class="subtitle-2 primary--text font-weight-regular px-4">Flatlogic.com</div> -->
          <!-- <v-list-item-group color="primary">
            <v-list-item
              v-for="(item, i) in account"
              :key="i">
                <v-list-item-icon class="mr-4">
                  <v-icon
                    :color="item.color"
                    v-text="item.icon">
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </v-list-item-group> -->
          <div class="d-flex justify-center my-3">
            <v-btn
              width="80%"
              large
              outlined
              color="primary"
              class="text-capitalize"
              @click="logOut">Sign Out
            </v-btn>
          </div>
        </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
  // import config from '../../config';
  // import Search from "@/components/Search/Search";
  
import {signOutFirebase} from "../../database.js";
import EquipoStore from "../../store/index";

  export default {
    name: 'Header',
    // components: { Search },
    data: () => ({
      // config,
      name:null,
      searchCollapse: true,
      menuIsOpen: false,
      notifications: [
        { text: 'Check out this awesome ticket', icon: 'mdi-tag', color: 'warning' },
        { text: 'What is the best way to get ...', icon: 'mdi-thumb-up', color: 'success'  },
        { text: 'This is just a simple notification', icon: 'mdi-flag', color: 'error'  },
        { text: '12 new orders has arrived today', icon: 'mdi-cart', color: 'primary'  },
      ],
      messages: [
        { text: 'JH', name: 'Jane Hew', message: 'Hey! How is it going?', time: '09:32', color: 'warning' },
        { text: 'LB', name: 'Lloyd Brown', message: 'Check out my new Dashboard', time: '10:02', color: 'success'  },
        { text: 'MW', name: 'Mark Winstein', message: 'I want rearrange the appointment', time: '12:16', color: 'error'  },
        { text: 'LD', name: 'Liana Dutti', message: 'Good news from sale department', time: '14:56', color: 'primary'  },
      ],
      account: [
        { text: 'Profile', icon: 'mdi-account', color: 'textColor' },
        { text: 'Tasks', icon: 'mdi-thumb-up', color: 'textColor'  },
        { text: 'Messages', icon: 'mdi-flag', color: 'textColor'  }
      ],
      notificationsBadge: true,
      messageBadge: true,
      drawer: false
    }),
    computed: {
      ...mapState({
         userlogged: state => state.userLogged, 
         userAuth: state => state.userAuth
      }),
      
    },
    created() {
      this.name = this.userlogged
    },
    methods: {
      // ...mapActions([ 'TOGGLE_DRAWER' ]),
      logOut: function () {
        window.localStorage.setItem('authenticated', false);
        signOutFirebase()
        EquipoStore.data.auth= false
        this.$router.push('/login');
      },
      toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
      this.$emit('menu-toggled', this.menuIsOpen);
      },
      
    }
  };
</script>

<style src="./Header.scss" lang="scss"></style>
